'use strict';

namespace Core {

    class CmsPageProps {
        private pageName: string;

        constructor (
            private $rootScope: ng.IRootScopeService
        ) {}

        $onInit(): void {
            this.$rootScope.$broadcast('cmsPageProps', {
                pageName: this.pageName
            });
        }
    }

    angular
        .module('core')
        .directive('cmsPageProps', (): ng.IDirective => {
            return {
                restrict: 'E',
                controller: CmsPageProps,
                controllerAs: 'cmsCtrl',
                bindToController: {
                    pageName: '@'
                },
                template: ``
            };
        });
}
